import React, { useState } from "react";
// import useFetch from "../../Controllers/useFetch";
import Loader from "../../Loader";
// import AnalysisCard from "./AnalysisCard";


const Analyse = () => {
  

  //console.log(chartData , "is chartData state" , keys)
  // console.log(dateHOC);

  // const { data, isLoading } = useFetch("analysis_page", "get", "/analytics", 0);

  
  if (true) {
    return (
      <div className="animated fadeIn">
        <Loader />
      </div>
    );
  } else {
    // //console.log(data.data.data);
    return (
      <div className="animated fadeIn">
        <div>
          {/* <AnalysisCard data={data.data.data} /> */}
        </div>
        
      </div>
    );
  }
};

export default Analyse;
